/* ==========================================================================
   REGINA – Herkunft-Seite · Motion & Funktionen
   Für sections/herkunft-*.liquid. Keine Abhängigkeiten.
   - Einblenden beim Scrollen
   - Klick: runterdrücken, beim Loslassen federnd zurück
   - Sanftes Scrollen zu Ankern (mit Abstand zur Navigation)
   - Sprungleiste: zeigt, wo man gerade ist (+ Fortschritt)
   - Honige: Sorte wählen → Text klappt auf, Landschaftsbild wechselt
   - Imker: Fotos wischen / ziehen / Punkte
   - Leichte Tiefe (Parallax) bei Fotos
   ========================================================================== */
(function () {
  'use strict';
  if (window.HK) return;
  var HK = (window.HK = {});

  var root = document.documentElement;
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduce = function () { return mq.matches; };
  var editor = root.classList.contains('hk-editor') || !!(window.Shopify && window.Shopify.designMode);

  /* ------------------------------------------------------------------
     Navigation des Themes messen (fix/sticky) → --hk-head
     ------------------------------------------------------------------ */
  var HEAD_SEL = 'header, .header, .site-header, .header-wrapper, #shopify-section-header, .shopify-section-group-header-group, [data-section-type="header"]';

  function posOf(el) {
    for (var n = el; n && n !== root; n = n.parentElement) {
      var p = getComputedStyle(n).position;
      if (p === 'fixed' || p === 'sticky' || p === 'absolute') return p;
    }
    return 'static';
  }

  var headEls = null;
  function collectHead() {
    headEls = [];
    document.querySelectorAll(HEAD_SEL).forEach(function (el) {
      if (el.closest('.hk') || el.closest('.hk-jump-host')) return;
      headEls.push(el);
    });
  }

  /* Unterkante einer sichtbaren festen/sticky Navigation */
  function headBottom() {
    if (!headEls) collectHead();
    var b = 0;
    headEls.forEach(function (el) {
      var p = posOf(el);
      if (p !== 'fixed' && p !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.height && r.bottom > 0 && r.top < 200) b = Math.max(b, r.bottom);
    });
    return Math.max(0, Math.round(b));
  }

  /* Liegt eine fixe/absolute Navigation über dem Hero? → Abstand oben */
  function measureOverlap(el) {
    if (!headEls) collectHead();
    var sec = el.closest('.shopify-section') || el;
    var secTop = sec.getBoundingClientRect().top + window.scrollY;
    var bottom = 0;
    headEls.forEach(function (h) {
      if (sec.contains(h) || h.contains(sec)) return;
      var p = posOf(h);
      if (p !== 'fixed' && p !== 'absolute') return;
      var r = h.getBoundingClientRect();
      if (!r.height) return;
      var b = p === 'fixed' ? r.bottom : r.bottom + window.scrollY;
      bottom = Math.max(bottom, b);
    });
    el.style.setProperty('--hk-overlap', Math.max(0, Math.round(bottom - secTop)) + 'px');
  }

  function isSticky(host) { return !!host && getComputedStyle(host).position === 'sticky'; }
  function barHeight() {
    var host = document.querySelector('.hk-jump-host');
    return isSticky(host) ? host.getBoundingClientRect().height : 0;
  }

  var lastHead = -1;
  function updateHead() {
    var h = headBottom();
    if (h !== lastHead) {
      lastHead = h;
      root.style.setProperty('--hk-head', h + 'px');
    }
    root.style.setProperty('--hk-bar', Math.round(barHeight()) + 'px');
  }

  /* ------------------------------------------------------------------
     Sanft zu einem Ziel scrollen
     ------------------------------------------------------------------ */
  function scrollToEl(target) {
    var y = target.getBoundingClientRect().top + window.scrollY - headBottom() - barHeight() - 12;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce() ? 'auto' : 'smooth' });
  }
  HK.scrollTo = scrollToEl;

  function findTarget(hash) {
    if (!hash || hash.length < 2) return null;
    var id;
    try { id = decodeURIComponent(hash.slice(1)); } catch (e) { id = hash.slice(1); }
    return document.getElementById(id);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || !a.closest('.hk, .hk-jump-host') || e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.pathname !== location.pathname || url.origin !== location.origin) return;
    var target = findTarget(url.hash);
    if (!target) return;
    e.preventDefault();

    // Pfeil zeigt die Richtung, dann fährt die Seite hin
    if (a.hasAttribute('data-hk-arrow') && !reduce()) {
      a.classList.remove('is-go'); void a.offsetWidth; a.classList.add('is-go');
      setTimeout(function () { a.classList.remove('is-go'); }, 800);
    }
    var jump = a.closest('.hk-jump');
    if (jump && jump.__hk) jump.__hk.lockTo(a);

    scrollToEl(target);
    if (history.replaceState) history.replaceState(null, '', url.hash);
  });

  /* ------------------------------------------------------------------
     Klick: runterdrücken & federnd loslassen
     ------------------------------------------------------------------ */
  var pressed = null;
  function release(el) {
    if (!el) return;
    el.classList.remove('is-pressed');
    if (reduce()) return;
    el.classList.remove('is-released'); void el.offsetWidth; el.classList.add('is-released');
  }
  document.addEventListener('pointerdown', function (e) {
    if (e.button !== 0) return;
    var el = e.target.closest && e.target.closest('[data-hk-press]');
    if (!el) return;
    pressed = el;
    el.classList.remove('is-released');
    el.classList.add('is-pressed');
  });
  ['pointerup', 'pointercancel'].forEach(function (t) {
    document.addEventListener(t, function () { if (pressed) { release(pressed); pressed = null; } });
  });
  document.addEventListener('pointerout', function (e) {
    if (pressed && e.target === pressed && !pressed.contains(e.relatedTarget)) {
      pressed.classList.remove('is-pressed');
      pressed = null;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest && e.target.closest('[data-hk-press]');
    if (!el || e.repeat) return;
    el.classList.add('is-pressed');
    setTimeout(function () { release(el); }, 110);
  });
  document.addEventListener('animationend', function (e) {
    if (e.animationName === 'hkRelease') e.target.classList.remove('is-released');
  });

  /* ------------------------------------------------------------------
     Einblenden beim Scrollen
     ------------------------------------------------------------------ */
  /* Hinweis: Elemente mit clip-path gelten für den IntersectionObserver als
     unsichtbar – darum wird bei Bild-Reveals das Elternelement beobachtet. */
  var io = null, watchMap = new Map();
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        (watchMap.get(en.target) || [en.target]).forEach(function (t) { t.classList.add('is-in'); });
        watchMap.delete(en.target);
        io.unobserve(en.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  }
  function initReveal(scope) {
    scope.querySelectorAll('[data-hk-reveal]:not(.is-in)').forEach(function (el) {
      if (!io || editor || reduce()) { el.classList.add('is-in'); return; }
      var watch = el.getAttribute('data-hk-reveal') === 'img' && el.parentElement ? el.parentElement : el;
      var list = watchMap.get(watch);
      if (list) { if (list.indexOf(el) === -1) list.push(el); return; }
      watchMap.set(watch, watch === el ? [el] : [el]);
      io.observe(watch);
    });
  }

  /* ------------------------------------------------------------------
     Parallax (leichte Tiefe)
     ------------------------------------------------------------------ */
  var plx = [];
  function initParallax(scope) {
    scope.querySelectorAll('[data-hk-plx]').forEach(function (el) {
      if (plx.indexOf(el) === -1) plx.push(el);
    });
  }
  function runParallax() {
    if (reduce() || !plx.length) return;
    var vh = window.innerHeight;
    plx = plx.filter(function (el) { return el.isConnected; });
    plx.forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var k = parseFloat(el.getAttribute('data-hk-plx')) || 0.06;
      var mid = r.top + r.height / 2 - vh / 2;
      el.style.transform = 'translate3d(0,' + (mid * -k).toFixed(1) + 'px,0)';
    });
  }

  /* ------------------------------------------------------------------
     Sprungleiste
     ------------------------------------------------------------------ */
  var jumps = [];
  function initJump(scope) {
    scope.querySelectorAll('.hk-jump').forEach(function (bar) {
      if (bar.__hk) return;
      var links = [].slice.call(bar.querySelectorAll('.hk-jump__link'));
      var dot = bar.querySelector('.hk-jump__dot');
      var prog = bar.querySelector('.hk-jump__progress');
      var host = bar.closest('.hk-jump-host');
      var lock = null, lockT = null, current = -1;

      function targets() {
        return links.map(function (a) { return findTarget(a.hash); });
      }
      function place(i) {
        if (!dot) return;
        if (i < 0) { dot.classList.remove('is-on'); return; }
        var a = links[i], wrap = a.parentElement.getBoundingClientRect(), r = a.getBoundingClientRect();
        dot.style.setProperty('--x', (r.left - wrap.left) + 'px');
        dot.style.setProperty('--w', r.width);
        dot.classList.add('is-on');
      }
      function setActive(i) {
        if (i === current) return;
        current = i;
        links.forEach(function (a, k) {
          if (k === i) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
        place(i);
      }
      function update() {
        var t = targets();
        var line = headBottom() + barHeight() + window.innerHeight * 0.3;
        var idx = -1;
        t.forEach(function (el, k) {
          if (el && el.getBoundingClientRect().top <= line) idx = k;
        });
        if (lock !== null) idx = lock;
        setActive(idx);

        if (isSticky(host)) {
          bar.classList.toggle('is-stuck', host.getBoundingClientRect().top <= headBottom() + 1 && window.scrollY > 10);
        }
        if (prog) {
          var first = t.filter(Boolean)[0];
          var p = 0;
          if (first) {
            var start = first.getBoundingClientRect().top + window.scrollY - line;
            var end = document.documentElement.scrollHeight - window.innerHeight;
            p = end > start ? (window.scrollY - start) / (end - start) : 0;
          }
          prog.style.setProperty('--p', Math.min(1, Math.max(0, p)).toFixed(4));
        }
      }
      bar.__hk = {
        update: update,
        relayout: function () { place(current); },
        lockTo: function (a) {
          lock = links.indexOf(a);
          setActive(lock);
          clearTimeout(lockT);
          lockT = setTimeout(function () { lock = null; update(); }, reduce() ? 50 : 900);
        }
      };
      jumps.push(bar);
      update();
    });
  }

  /* ------------------------------------------------------------------
     Honige: Sorte wählen
     ------------------------------------------------------------------ */
  function initHoney(scope) {
    scope.querySelectorAll('[data-hk-honey]').forEach(function (box) {
      if (box.__hk) return;
      var items = [].slice.call(box.querySelectorAll('.hk-honey__item'));
      var toggles = items.map(function (it) { return it.querySelector('.hk-honey__toggle'); });
      var slides = [].slice.call(box.querySelectorAll('.hk-honey__slide'));
      var caps = [].slice.call(box.querySelectorAll('.hk-honey__cap'));
      var marks = [].slice.call(box.querySelectorAll('.hk-honey__count span'));
      var cur = items.findIndex(function (it) { return it.classList.contains('is-open'); });

      function setOpen(it, k, on) {
        it.classList.toggle('is-open', on);
        toggles[k].setAttribute('aria-expanded', on ? 'true' : 'false');
        var inner = it.querySelector('.hk-honey__panel-in');
        if (inner) {
          if (on) { inner.removeAttribute('inert'); inner.removeAttribute('aria-hidden'); }
          else { inner.setAttribute('inert', ''); inner.setAttribute('aria-hidden', 'true'); }
        }
      }

      function show(i, user) {
        if (i < 0 || i >= items.length) return;
        if (i === cur) {
          // Offene Sorte nochmal antippen → zuklappen (Bild bleibt stehen)
          if (!user) return;
          setOpen(items[i], i, false);
          cur = -1;
          return;
        }
        cur = i;
        items.forEach(function (it, k) {
          var on = k === i;
          setOpen(it, k, on);
          it.classList.remove('is-hop');
        });
        [slides, caps, marks].forEach(function (list) {
          list.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
        });
        // Bild sofort laden, auch wenn es „lazy“ ist
        var img = slides[i] && slides[i].querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
        if (user && !reduce()) { void items[i].offsetWidth; items[i].classList.add('is-hop'); }
      }

      toggles.forEach(function (btn, k) {
        btn.addEventListener('click', function () { show(k, true); });
        btn.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowDown') n = (k + 1) % toggles.length;
          if (e.key === 'ArrowUp') n = (k - 1 + toggles.length) % toggles.length;
          if (e.key === 'Home') n = 0;
          if (e.key === 'End') n = toggles.length - 1;
          if (n === null) return;
          e.preventDefault();
          toggles[n].focus();
        });
        // Bild vorab laden, sobald man in die Nähe kommt
        btn.addEventListener('pointerenter', function () {
          var img = slides[k] && slides[k].querySelector('img');
          if (img && img.loading === 'lazy') img.loading = 'eager';
        });
      });
      items.forEach(function (it) {
        it.addEventListener('animationend', function (e) { if (e.animationName === 'hkHop') it.classList.remove('is-hop'); });
      });

      box.__hk = { show: show };
    });
  }

  /* ------------------------------------------------------------------
     Foto-Galerie (Imker): wischen, mit der Maus ziehen, Punkte, Pfeiltasten
     ------------------------------------------------------------------ */
  function initSwipe(scope) {
    scope.querySelectorAll('[data-hk-swipe]').forEach(function (track) {
      if (track.__hk) return;
      var slides = [].slice.call(track.children);
      var fig = track.closest('figure') || track.parentElement;
      var dots = [].slice.call(fig.querySelectorAll('.hk-person__dot'));
      var cur = 0;

      function width() { return track.clientWidth || 1; }
      function wake(i) {
        var img = slides[i] && slides[i].querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      }
      function mark(i) {
        if (i === cur) return;
        cur = i;
        slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === i);
          if (k === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
        dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === i);
          if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
        wake(i + 1);
      }
      function go(i, smooth) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        wake(i);
        track.classList.add('is-touched');
        track.scrollTo({ left: i * width(), behavior: smooth === false || reduce() ? 'auto' : 'smooth' });
        mark(i);
      }

      // Welches Foto ist gerade zu sehen?
      var sT = null;
      track.addEventListener('scroll', function () {
        if (sT) return;
        sT = requestAnimationFrame(function () {
          sT = null;
          if (!dragging) mark(Math.round(track.scrollLeft / width()));
        });
      }, { passive: true });

      // Sobald jemand anfasst, keinen „Wink“ mehr
      track.addEventListener('touchstart', function () { track.classList.add('is-touched'); wake(cur + 1); }, { passive: true });

      // Desktop: mit der Maus ziehen
      var dragging = false, startX = 0, startLeft = 0, moved = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true; moved = 0;
        startX = e.clientX; startLeft = track.scrollLeft;
        track.classList.add('is-dragging', 'is-touched');
        wake(cur + 1); wake(cur - 1);
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        moved = e.clientX - startX;
        track.scrollLeft = startLeft - moved;
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        var w = width(), base = Math.round(startLeft / w);
        // schon ein kurzer Zug reicht zum Blättern
        var target = Math.abs(moved) > w * 0.12 ? base + (moved < 0 ? 1 : -1) : base;
        // Einrasten erst wieder einschalten, wenn das Foto angekommen ist –
        // sonst springt der Browser zum nächstgelegenen Foto zurück
        track.classList.remove('is-dragging');
        track.classList.add('is-gliding');
        go(target);
        clearTimeout(glideT);
        glideT = setTimeout(function () { track.classList.remove('is-gliding'); }, reduce() ? 0 : 650);
      }
      var glideT = null;
      track.addEventListener('scrollend', function () {
        if (!dragging) { clearTimeout(glideT); track.classList.remove('is-gliding'); }
      });
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('lostpointercapture', endDrag);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // Tastatur
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      });

      // Punkte
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () { go(k); });
        d.addEventListener('pointerenter', function () { wake(k); });
      });

      track.__hk = { go: go, relayout: function () { go(cur, false); } };
      swipes.push(track);
    });
  }
  var swipes = [];

  /* ------------------------------------------------------------------
     Start & Theme-Editor
     ------------------------------------------------------------------ */
  function init(scope) {
    scope = scope || document;
    collectHead();
    scope.querySelectorAll('[data-hk-overlap]').forEach(measureOverlap);
    initReveal(scope);
    initParallax(scope);
    initJump(scope);
    initHoney(scope);
    initSwipe(scope);
    updateHead();
    runParallax();
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      updateHead();
      jumps = jumps.filter(function (b) { return b.isConnected; });
      jumps.forEach(function (b) { b.__hk.update(); });
      runParallax();
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* Viele Themes blenden die Navigation beim Scrollen mit einer Animation aus/ein –
     die läuft weiter, wenn schon kein Scroll-Ereignis mehr kommt. Darum nach jedem
     Scrollen noch kurz Bild für Bild nachmessen, damit die Sprungleiste exakt folgt. */
  var followUntil = 0, following = false;
  function follow() {
    updateHead();
    jumps.forEach(function (b) { if (b.isConnected) b.__hk.update(); });
    if (performance.now() < followUntil) requestAnimationFrame(follow);
    else following = false;
  }
  function startFollow() {
    followUntil = performance.now() + 900;
    if (!following) { following = true; requestAnimationFrame(follow); }
  }
  window.addEventListener('scroll', startFollow, { passive: true });
  ['transitionend', 'animationend'].forEach(function (t) {
    document.addEventListener(t, function (e) {
      if (e.target && e.target.closest && e.target.closest(HEAD_SEL)) startFollow();
    }, true);
  });

  var rT;
  window.addEventListener('resize', function () {
    clearTimeout(rT);
    rT = setTimeout(function () {
      collectHead();
      document.querySelectorAll('[data-hk-overlap]').forEach(measureOverlap);
      jumps.forEach(function (b) { b.__hk.relayout(); });
      swipes = swipes.filter(function (t) { return t.isConnected; });
      swipes.forEach(function (t) { t.__hk.relayout(); });
      onScroll();
    }, 120);
  });
  window.addEventListener('load', function () {
    document.querySelectorAll('[data-hk-overlap]').forEach(measureOverlap);
    jumps.forEach(function (b) { b.__hk.relayout(); });
    onScroll();
    // Mit #anker aufgerufen? Erst nach dem Laden passend hinscrollen
    var t = findTarget(location.hash);
    if (t && t.closest('.hk, .shopify-section')) setTimeout(function () { scrollToEl(t); }, 60);
  });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { jumps.forEach(function (b) { b.__hk.relayout(); }); });
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var box = e.target.closest && e.target.closest('[data-hk-honey]');
    if (!box || !box.__hk) return;
    var items = [].slice.call(box.querySelectorAll('.hk-honey__item'));
    box.__hk.show(items.indexOf(e.target.closest('.hk-honey__item')), false);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
